<template>
  <div class="min-h-screen bg-base-100 flex flex-col">
    <MainHeader :isSticky="false" :isMinimal="false" :scrolled="false" />
    <HeroHeader :title="translatedTitle" :subtitle="translatedSubtitle" />
    <div class="container mx-auto px-4 py-16">
      <main>
        <router-view />
      </main>
    </div>
    <Footer />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useI18n } from "vue-i18n";
import MainHeader from "@/components/headers/MainHeader.vue";
import HeroHeader from "@/components/sections/general/HeroHeader.vue";
import Footer from "@/components/Footer.vue";

// get route and i18n
const route = useRoute();
const { t } = useI18n();

// Helper to get the deepest matched route (the child view)
const activeMeta = computed(() => {
  const matched = route.matched;
  return matched.length ? matched[matched.length - 1].meta : {};
});

// Now fetch the translated title and subtitle
const translatedTitle = computed(() => {
  const key = activeMeta.value?.titleKey;
  return key ? t(key) : "";
});

const translatedSubtitle = computed(() => {
  const key = activeMeta.value?.subtitleKey;
  return key ? t(key) : "";
});
</script>
